import React, { FC, useState } from 'react';
import { Button, Tooltip, Modal, Form, Select } from 'antd';
import { withTranslation, WithTranslation } from 'react-i18next';

export interface ExportButtonWithModalProps extends WithTranslation {
  onExport: (separator: string) => void;
  text?: string;
  tooltip?: string;
  modalText?: string;
}

const ExportButtonWithModal: FC<ExportButtonWithModalProps> = ({ t, onExport, text, tooltip, modalText }) => {
  const [exportModal, setExportModal] = useState(false);
  const [selectedSeparator, setSelectedSeparator] = useState(',');
  const [form] = Form.useForm();

  const handleExportOk = async () => {
    onExport(selectedSeparator);
    setExportModal(false);
  };

  const handleExportCancel = () => {
    setExportModal(false);
  };

  const onClick = () => {
    setExportModal(!exportModal);
  };

  const onChangeItem = (separator: string) => {
    setSelectedSeparator(separator);
  };

  return (
    <>
      <Tooltip placement="top" title={tooltip || text || t('ExportCSV')}>
        <Button type="primary" style={{ width: 'auto', minWidth: 'max-content' }} onClick={onClick}>
          {text || t('ExportCSV')}
        </Button>
      </Tooltip>
      {exportModal && (
        <Modal
          title={<h3>{`${t('Reports')}`}</h3>}
          open={exportModal}
          onOk={handleExportOk}
          onCancel={handleExportCancel}
          okText={t(modalText || 'Export')}
          cancelText={t('Cancel')}
          cancelButtonProps={{ type: 'default' }}
        >
          <Form form={form} layout="vertical" autoComplete="off">
            <Form.Item initialValue={','} name={'csvSeparator'} label={t('Separator')}>
              <Select onChange={onChangeItem}>
                <Select.Option value={','}>{t('Comma')}</Select.Option>
                <Select.Option value={';'}>{t('Semicolon')}</Select.Option>
                <Select.Option value={'\t'}>{t('Tab')}</Select.Option>
              </Select>
            </Form.Item>
          </Form>
        </Modal>
      )}
    </>
  );
};
export default withTranslation()(ExportButtonWithModal);
